import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-2", staticStyle: { width: "100%" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("app-title", { attrs: { texto: "SELEÇÃO DAS UNIDADES" } })],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [
          _c("selecao-unidade", {
            model: {
              value: _vm.filtro.selecaoUnidade,
              callback: function ($$v) {
                _vm.$set(_vm.filtro, "selecaoUnidade", $$v)
              },
              expression: "filtro.selecaoUnidade",
            },
          }),
        ],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("app-title", { attrs: { texto: "CADASTRO" } })],
        1
      ),
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("filtro-base", { attrs: { value: _vm.filtro.pessoal } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }